export function detectSubtasksPending(gantt, taskId) {
  const children = gantt.getChildren(taskId);

  for (const childId of children) {
    const child = gantt.getTask(childId);
    if (child.modificationSource === 'pending') {
      return true;
    }
    const hasPendingDescendant = detectSubtasksPending(gantt, childId);
    if (hasPendingDescendant) {
      return true;
    }
  }
  return false;
}
